<template>
  <div class="container">
    <div class="conditions_box">
      <img src="@/assets/archedShape2.png" class="img-fluid gonbad"/>

      <div class="row">

        <div class="col-12 col-md-10 mx-auto">
          <div class="content-wrapper">
            <h1>ثبت نام اولیه سامانه پلیس امنیت</h1>
            <div class="card content-box">
              <div class="card-body">
                <h4 class="pt-4">چند نکته مهم قبل از ثبت نام نهایی</h4>
                <br/>
                <p class="bold-p px-2">
                  1- دوباره عرض میشود: سامانه ناظر یک دارای قدرت اجرایی و قضایی است و اگر فردی تایید گردد، باید نهایت دقت را در ثبت درست تخلف و شماره پلاک و تطبیق آن مدل و رنگ ماشین مد نظر داشته باشد که خدای نکرده اشتباهی حاصل نشود.
                </p>
                <p class="bold-p px-2">
                  2- روند اجرایی کار به این نحو است که پس از ثبت نام شما در صفحه بعد، مدارک شما بررسی میگردد و در صورت تایید، بعد از مدت حداکثر یک ماه برای شما پیامک ثبت نرم افزار در موبایلتان ارسال می گردد
                </p>
                <p class="bold-p px-2">
                  جهت ثبت نام نهایی به صفحه بعد مراجعه بفرمایید.
                </p>
                <br/>
                <RouterLink to="/faq" class="bbot mx-auto">
                  ▶ صفحه قبل
                </RouterLink>
                <RouterLink to="/complete-form" class="bbot mx-auto">
                  صفحه بعد ◀
                </RouterLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FinalExamRuleView"
}
</script>

<style scoped>

</style>